export const UnexpectedError = `An unexpected error has occurred`;

export const PaymentProcessingError = `There was an issue with the processing of your payment. DO NOT attempt to pay again because that can result in a double payment. Please contact questions@abpn.org to find out if your payment was received.`;

export const ErrorMessages : { [key: string]: string } = {
    UnexpectedError: UnexpectedError,
    PaymentProcessingError: PaymentProcessingError
}